import { Environment } from '@app-utils';

export const environment: Environment = {
  prod: false,
  apiBase: 'https://dev-api.aureliusconsilium.com.au',
};